import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import React from 'react';
import { getProductTypeLabel, getFundsManagementCompaniesPath } from '@finect/front-resources/Products';
import { useTheme } from 'styled-components';
import { Section } from '../../Section';
import { ManagementCompany } from '../../Products';
export var CategoryManagementCompanies = function CategoryManagementCompanies(_ref) {
  var productType = _ref.productType,
    category = _ref.category;
  var theme = useTheme();
  var managementCompanies = category.managementCompanies ? category.managementCompanies : [];
  return React.createElement(Section, {
    title: "Gestoras en la categor\xEDa",
    subtitle: "".concat(managementCompanies.length, " gestoras han invertido en la categor\xEDa ").concat(category.name, " a trav\xE9s de ").concat(category.stats.funds, " ").concat(getProductTypeLabel(productType, 'shortPlural', 'lowercase'), " "),
    bottomMargin: true,
    link: {
      text: "Ver todas las gestoras de ".concat(getProductTypeLabel(productType, 'plural', 'lowercase')),
      href: getFundsManagementCompaniesPath(theme, productType)
    }
  }, React.createElement("div", null, managementCompanies.slice(0, 10).map(function (managementCompany) {
    return React.createElement(ManagementCompany, {
      key: managementCompany.id,
      variant: "tag",
      managementCompany: managementCompany,
      productType: productType
    });
  })));
};